import Phaser from "phaser";

export default class StatusMessage extends Phaser.GameObjects.Sprite {
    constructor(scene, x, y, scale) {
        super(scene, x, y);
        this.scale = scale;
        this.message = "";

        this.scaleFactor = null;

        this.playerBonez = null;
        this.playerLevels = null;

        this.opponentBonez = null;
        this.opponentLevels = null;

        this.setScaleFactor(this.scale);

        this.waitTime = null; 
        this.waitMatchContainer = this.scene.add.container(this.x - this.scaleFactor.container.x, this.y - this.scaleFactor.container.y).setVisible(true).setDepth(this.depth + 4); // - 2000, - 1000

        this.playerGraphics = this.scene.add.graphics();
        this.playerGraphics.fillStyle(0xffffff); 
        this.playerGraphics.fillCircle(this.x - 600 + this.scaleFactor.pfp.x, this.y - 600 + this.scaleFactor.pfp.y, this.scaleFactor.pfp.radius); 
        this.playerGraphics.setVisible(false);
        this.playerMask = new Phaser.Display.Masks.GeometryMask(this, this.playerGraphics);
        this.playerMaskAvatar = this.scene.add.image(this.x - 600 + this.scaleFactor.pfp.x, this.y - 600 + this.scaleFactor.pfp.y, 'pfpPlayer').setScale(3.5*this.scale).setDepth(this.depth + 6).setMask(this.playerMask);
        this.playerMaskAvatar.setVisible(false);

        this.opponentGraphics = this.scene.add.graphics();
        this.opponentGraphics.fillStyle(0xffffff); 
        this.opponentGraphics.fillCircle(this.x + 500 + this.scaleFactor.pfp.x*1.175, this.y - 600 + this.scaleFactor.pfp.y, this.scaleFactor.pfp.radius); 
        this.opponentGraphics.setVisible(false);
        this.opponentMask = new Phaser.Display.Masks.GeometryMask(this, this.opponentGraphics);
        this.opponentMaskAvatar = this.scene.add.image(this.x + 500 + this.scaleFactor.pfp.x*1.175, this.y - 600 + this.scaleFactor.pfp.y, 'pfpOpponent').setScale(3.5*this.scale).setDepth(this.depth + 6).setMask(this.opponentMask);
        this.opponentMaskAvatar.setVisible(false);
    }

    async displayWaitingMatchStart(client, session, data) {
        if (data.sleepTimer <= 1) {
            this.playerGraphics.destroy();
            this.playerMaskAvatar.destroy();
            this.opponentGraphics.destroy();
            this.opponentMaskAvatar.destroy();

            // rejoin catch hook
            this.playerGraphics.setVisible(false);
            this.playerMaskAvatar.setVisible(false);
            this.opponentGraphics.setVisible(false);
            this.opponentMaskAvatar.setVisible(false);

            this.waitMatchContainer.setVisible(false);
        } else {
            this.playerGraphics.setVisible(true);
            this.playerMaskAvatar.setVisible(true);
            this.opponentGraphics.setVisible(true);
            this.opponentMaskAvatar.setVisible(true);

            this.waitMatchContainer.setVisible(true);
        }

        this.playerBonez = await this.getPlayerBonez(client, session, data.player.userId);
        this.playerLevels = await this.getPlayerLevels(client, session, data.player.userId);

        this.opponentBonez = await this.getPlayerBonez(client, session, data.opponent.userId);
        this.opponentLevels = await this.getPlayerLevels(client, session, data.opponent.userId);

        //Draw the player_waiting_panel
        this.gameWaitBackground = this.scene.add.graphics();
        this.gameWaitBackground.fillStyle(0x161b2f, 0.5);
        this.gameWaitBackground.fillRoundedRect(this.x - 800, this.y - 950, 1800, 1800, 50);
        this.gameWaitBackground.lineStyle(4, 0x00d1ff, 1);
        this.gameWaitBackground.strokeRoundedRect(this.x - 800, this.y - 950, 1800, 1800, 50); // Add this line to draw the border
        this.gameWaitBackground.setDepth(this.depth + 2);
        this.gameWaitBackground.setVisible(true);
        

        //this.gameWaitBackground = this.scene.add.image(this.x + 950, this.y + 650, 'all_images', 'player_wait_panel').setOrigin(1, 1).setDepth(this.depth + 2).setScale(this.scale * 1.65);
        this.chipzIcon1 = this.scene.add.image(this.x + 165*this.scaleFactor.image.x1, this.y + 305 + this.scaleFactor.image.y1, 'all_images', 'chipz_icon').setOrigin(1, 1).setDepth(this.depth + 3).setScale(this.scale * 0.55);
        this.chipzIcon2 = this.scene.add.image(this.x + 165*this.scaleFactor.image.x1, this.y + 385 + this.scaleFactor.image.y1, 'all_images', 'chipz_icon').setOrigin(1, 1).setDepth(this.depth + 3).setScale(this.scale * 0.55);
        this.bonezIcon1 = this.scene.add.image(this.x + 170*this.scaleFactor.image.x2, this.y + 465 + this.scaleFactor.image.y2, 'all_images', 'bone').setOrigin(1, 1).setDepth(this.depth + 3).setScale(this.scale * 0.025);
        this.bonezIcon2 = this.scene.add.image(this.x + 170*this.scaleFactor.image.x2, this.y + 540 + this.scaleFactor.image.y2, 'all_images', 'bone').setOrigin(1, 1).setDepth(this.depth + 3).setScale(this.scale * 0.025);
        this.levelIcon1 = this.scene.add.image(this.x - 480*this.scaleFactor.level.x1, this.y - 260 + this.scaleFactor.level.y1*0.9 , 'all_images', 'level_panel').setOrigin(1, 1).setDepth(this.depth + 3).setScale(this.scale * 1.75);
        this.levelIcon2 = this.scene.add.image(this.x + 620*this.scaleFactor.level.x2, this.y - 260 + this.scaleFactor.level.y2*0.9 , 'all_images', 'level_panel').setOrigin(1, 1).setDepth(this.depth + 3).setScale(this.scale * 1.75);

        this.waitCountDown = this.scene.add.text(this.x + 125*this.scaleFactor.textMain.x, this.y - 600 + this.scaleFactor.textMain.y, 'Game Starting in ' + (data.sleepTimer - 1), { fontSize: 95*this.scale + "px", fontFamily: "TruculentaBold", fill: '#5A4F71', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);

        // player and opponent texts
        this.player = this.scene.add.text(this.x - 450*this.scaleFactor.text.x1, this.y - 450 + this.scaleFactor.textStat.y, data.player.username, { fontSize: 70*this.scale + "px", fontFamily: "TruculentaBold", fill: '#00D1FF', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);
        this.playerStat0 = this.scene.add.text(this.x - 540*this.scaleFactor.textLevel.x1, this.y - 350 + this.scaleFactor.textLevel.y*0.9, this.playerLevels.level, { fontSize: 65*this.scale + "px", fontFamily: "TruculentaBold", fill: '#000000', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 4);
        this.playerStat1 = this.scene.add.text(this.x - 410*this.scaleFactor.textLevel.x4, this.y - 350 + this.scaleFactor.textLevel.y*0.9, this.playerLevels.xp, { fontSize: 65*this.scale + "px", fontFamily: "TruculentaBold", fill: '#FFC350', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);
        if (this.playerBonez.winStreak > 0) {
            console.log('player bonez winstreak will appear');
            this.playerStat2 = this.scene.add.text(this.x - 455*this.scaleFactor.text.x1, this.y - 250 + this.scaleFactor.textStat.y*0.9, this.playerBonez.winStreak + ' WIN STREAK!', { fontSize: 65*this.scale + "px", fontFamily: "TruculentaBold", fill: '#FF7A00', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 5);
            this.waitMatchContainer.add([this.playerStat2]);
        }
        this.playerStat3 = this.scene.add.text(this.x - 455*this.scaleFactor.text.x1, this.y - 100 + this.scaleFactor.text.y*1.5, this.playerBonez.wins, { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#00F955', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);
        this.playerStat4 = this.scene.add.text(this.x - 455*this.scaleFactor.text.x1, this.y - 25 + this.scaleFactor.text.y*1.5, this.playerBonez.totalRoundsWon, { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#FFC350', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);
        this.playerStat5 = this.scene.add.text(this.x - 455*this.scaleFactor.text.x1, this.y + 50 + this.scaleFactor.text.y*1.5, this.playerBonez.losses, { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold",fill: '#FF0A54', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);
        this.playerStat6 = this.scene.add.text(this.x - 455*this.scaleFactor.text.x1, this.y + 125 + this.scaleFactor.text.y*1.5, this.playerBonez.forfeits, { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#9488AE', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);
        this.playerStat7 = this.scene.add.text(this.x - 455*this.scaleFactor.text.x1, this.y + 270 + this.scaleFactor.text.y, this.playerBonez.zoomWon, { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#00D1FF', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);
        this.playerStat8 = this.scene.add.text(this.x - 455*this.scaleFactor.text.x1, this.y + 345 + this.scaleFactor.text.y, this.playerBonez.zoomLost, { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#585EDD', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);
        this.playerStat9 = this.scene.add.text(this.x - 455*this.scaleFactor.text.x1, this.y + 420 + this.scaleFactor.text.y, this.playerBonez.bonezWon, { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#B2F1FF', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);
        this.playerStat10 = this.scene.add.text(this.x - 455*this.scaleFactor.text.x1, this.y + 495 + this.scaleFactor.text.y, this.playerBonez.bonezLost, { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#9B8B6B', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);

        this.opponent = this.scene.add.text(this.x + 650*this.scaleFactor.text.x2, this.y - 450 + this.scaleFactor.textStat.y, data.opponent.username, { fontSize: 70*this.scale + "px", fontFamily: "TruculentaBold", fill: '#00D1FF', align: 'center' }).setOrigin(0.5, 0.5).setDepth(this.depth + 3);
        this.opponentStat0 = this.scene.add.text(this.x + 560*this.scaleFactor.textLevel.x3, this.y - 350 + this.scaleFactor.textLevel.y*0.9, this.opponentLevels.level, { fontSize: 65*this.scale + "px", fontFamily: "TruculentaBold", fill: '#000000', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 4);
        this.opponentStat1 = this.scene.add.text(this.x + 695*this.scaleFactor.textLevel.x2, this.y - 350 + this.scaleFactor.textLevel.y*0.9, this.opponentLevels.xp, { fontSize: 65*this.scale + "px", fontFamily: "TruculentaBold", fill: '#FFC350', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);
        if (this.opponentBonez.winStreak > 0) {
            console.log('opponent bonez winstreak will appear');
            this.opponentStat2 = this.scene.add.text(this.x + 655*this.scaleFactor.text.x2, this.y - 250 + this.scaleFactor.textStat.y*0.9, this.opponentBonez.winStreak + ' WIN STREAK!', { fontSize: 65*this.scale + "px", fontFamily: "TruculentaBold", fill: '#FF7A00', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 5);
            this.waitMatchContainer.add([this.opponentStat2]);
        }
        this.opponentStat3 = this.scene.add.text(this.x + 655*this.scaleFactor.text.x2, this.y - 100 + this.scaleFactor.text.y*1.5, this.opponentBonez.wins, { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#00F955', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);
        this.opponentStat4 = this.scene.add.text(this.x + 655*this.scaleFactor.text.x2, this.y - 25 + this.scaleFactor.text.y*1.5, this.opponentBonez.totalRoundsWon, { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#FFC350', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);
        this.opponentStat5 = this.scene.add.text(this.x + 655*this.scaleFactor.text.x2, this.y + 50 + this.scaleFactor.text.y*1.5, this.opponentBonez.losses, { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold",fill: '#FF0A54', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);
        this.opponentStat6 = this.scene.add.text(this.x + 655*this.scaleFactor.text.x2, this.y + 125 + this.scaleFactor.text.y*1.5, this.opponentBonez.forfeits, { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#9488AE', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);
        this.opponentStat7 = this.scene.add.text(this.x + 655*this.scaleFactor.text.x2, this.y + 270 + this.scaleFactor.text.y, this.opponentBonez.zoomWon, { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#00D1FF', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);
        this.opponentStat8 = this.scene.add.text(this.x + 655*this.scaleFactor.text.x2, this.y + 345 + this.scaleFactor.text.y, this.opponentBonez.zoomLost, { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#585EDD', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);
        this.opponentStat9 = this.scene.add.text(this.x + 655*this.scaleFactor.text.x2, this.y + 420 + this.scaleFactor.text.y, this.opponentBonez.bonezWon, { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#B2F1FF', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);
        this.opponentStat10 = this.scene.add.text(this.x + 655*this.scaleFactor.text.x2, this.y + 495 + this.scaleFactor.text.y, this.opponentBonez.bonezLost, { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#9B8B6B', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3);

        this.waitMatchContainer.add([
            this.gameWaitBackground,
            this.bonezIcon1,
            this.bonezIcon2,
            this.chipzIcon1,
            this.chipzIcon2,
            this.levelIcon1,
            this.levelIcon2,

            // panel texts
            this.waitCountDown,
            this.scene.add.text(this.x + 125*this.scaleFactor.textLabel.x1, this.y - 400 + this.scaleFactor.textLabel.y*3.75, 'VS', { fontSize: 110*this.scale + "px", fontFamily: "TruculentaBold", fill: '#5A4F71', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3),
            this.scene.add.text(this.x + 125*this.scaleFactor.textLabel.x1, this.y - 100 + this.scaleFactor.textLabel.y*1.5, 'GAMES WON', { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#00F955', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3),
            this.scene.add.text(this.x + 125*this.scaleFactor.textLabel.x1, this.y - 25 + this.scaleFactor.textLabel.y*1.5, 'ROUNDS WON', { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#FFC350', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3),
            this.scene.add.text(this.x + 125*this.scaleFactor.textLabel.x1, this.y + 50 + this.scaleFactor.textLabel.y*1.5, 'GAMES LOST', { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#FF0A54', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3),
            this.scene.add.text(this.x + 125*this.scaleFactor.textLabel.x1, this.y + 125 + this.scaleFactor.textLabel.y*1.5,'FORFEITS', { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#9488AE', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3),

            this.scene.add.text(this.x + 20*this.scaleFactor.textLabel.x2, this.y + 275 + this.scaleFactor.textLabel.y,'TOTAL', { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#00D1FF', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3),
            this.scene.add.text(this.x + 240*this.scaleFactor.textLabel.x3, this.y + 275 + this.scaleFactor.textLabel.y,'WON', { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#00D1FF', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3),
            this.scene.add.text(this.x + 20*this.scaleFactor.textLabel.x2, this.y + 350 + this.scaleFactor.textLabel.y,'TOTAL', { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#585EDD', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3),
            this.scene.add.text(this.x + 240*this.scaleFactor.textLabel.x3, this.y + 350 + this.scaleFactor.textLabel.y,'LOST', { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#585EDD', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3),

            this.scene.add.text(this.x + 20*this.scaleFactor.textLabel.x2, this.y + 425 + this.scaleFactor.textLabel.y,'TOTAL', { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#B2F1FF', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3),
            this.scene.add.text(this.x + 240*this.scaleFactor.textLabel.x3, this.y + 425 + this.scaleFactor.textLabel.y,'WON', { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#B2F1FF', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3),
            this.scene.add.text(this.x + 20*this.scaleFactor.textLabel.x2, this.y + 500 + this.scaleFactor.textLabel.y,'TOTAL', { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#9B8B6B', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3),
            this.scene.add.text(this.x + 240*this.scaleFactor.textLabel.x3, this.y + 500 + this.scaleFactor.textLabel.y,'LOST', { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#9B8B6B', align: 'center'}).setOrigin(0.5, 0.5).setDepth(this.depth + 3),

            this.player,
            this.playerStat0,
            this.playerStat1,
            this.playerStat3, 
            this.playerStat4,
            this.playerStat5,
            this.playerStat6,
            this.playerStat7,
            this.playerStat8,
            this.playerStat9,
            this.playerStat10,

            this.opponent,
            this.opponentStat0,
            this.opponentStat1,
            this.opponentStat3, 
            this.opponentStat4,
            this.opponentStat5,
            this.opponentStat6,
            this.opponentStat7,
            this.opponentStat8,
            this.opponentStat9,
            this.opponentStat10,
        ]);
    }

    async getPlayerBonez(client, session, id) {
        const objects = await client.readStorageObjects(session, {
            "object_ids": [{
                "collection": "bonez_matches",
                "key": "bonez_matches",
                "user_id": id
            }]
        });
        
        return objects.objects[0].value.data;
    }

    async getPlayerLevels(client, session, id) {
        const objects = await client.readStorageObjects(session, {
            "object_ids": [{
                "collection": "user_levels",
                "key": "user_levels",
                "user_id": id
            }]
        });
        
        return objects.objects[0].value.data;
    }

    setScaleFactor(scale) {
        if (scale !== 1) {
            // Mobile
            this.scaleFactor = {
                container: {
                    x: 1155,
                    y: 800
                },
                text: {
                    x1: 0,
                    x2: 1.2,
                    y: 90
                },
                textLabel: {
                    x1: 3.25,
                    x2: 16.25,
                    x3: 2,
                    y: 90
                },
                textMain: {
                    x: 3.25,
                    y: 420
                },
                textStat: {
                    y: 275
                },
                image: {
                    x1: 2.6,
                    x2: 2.55,
                    y1: 82.5,
                    y2: 75,
                },
                pfp: {
                    x: 265,
                    y: 585,
                    radius: 110.88
                },
                level: {
                    x1: 0.05,
                    x2: 1.25,
                    y1: 234,
                    y2: 234,
                },
                textLevel: {
                    x1: 0.125,
                    x2: 1.21,
                    x3: 1.31,
                    x4: -0.1,
                    y: 275,
                }
            }
        } else {
            // Desktop
            this.scaleFactor = {
                container: {
                    x: 1200,
                    y: 1000
                },
                text: {
                    x1: 1,
                    x2: 1,
                    y: 0
                },
                textLabel: {
                    x1: 1,
                    x2: 1,
                    x3: 1,
                    y: 0
                },
                textMain: {
                    x: 1,
                    y: 0
                },
                textStat: {
                    y: 0
                },
                image: {
                    x1: 1,
                    x2: 1,
                    y1: 1,
                    y2: 0
                },
                pfp: {
                    x: 350,
                    y: -50,
                    radius: 168
                },
                level: {
                    x1: 1,
                    x2: 1,
                    y1: 1,
                    y2: 0
                },
                textLevel: {
                    x1: 1,
                    x2: 1,
                    x3: 1,
                    x4: 1,
                    y: 0,
                }
            }
        }
    }

    displayPlayerTurn(username) {
        if (this.message === ""){
            this.message = this.scene.add.text(this.x*1.23, this.y*1.065, `${username}'s turn`, { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#BD00FF', align: 'right' }).setOrigin(1, 0.5).setDepth(this.depth + 3);
        }
        else {
            this.message.setText(`${username}'s turn`)
        }
        const tween = this.scene.tweens.add({
            targets: this.message,
            scale: 1.2, // Final x position
            duration: 200, // Duration of the tween in milliseconds
            ease: 'Power2', // Easing function
            //yoyo: true, // Will make the tween go back and forth
            loop: 1, // Infinite loop
            onComplete: () => {
                tween.remove();
            }
            //paused: true // Start the tween paused
        });
    }

    displayPlayerStand(username) {
        if (this.message === ""){
            this.message = this.scene.add.text(this.x, this.y, `${username} is standing`, { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#BD00FF', align: 'right' }).setOrigin(1, 0.5).setDepth(this.depth + 3);
        }
        else {
            this.message.setText(`${username} is standing`)
        }
        const tween = this.scene.tweens.add({
            targets: this.message,
            scale: 1.5, // Final x position
            duration: 300, // Duration of the tween in milliseconds
            ease: 'Power2', // Easing function
            loop: 1, // Infinite loop
            onComplete: () => {
                tween.remove();
            }
            //paused: true // Start the tween paused
        });
    }

    displayRoundWin(username) {
        if (this.message === ""){
            this.message = this.scene.add.text(this.x, this.y, `${username} wins the round!`, { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#BD00FF', align: 'right' }).setOrigin(1, 0.5).setDepth(this.depth + 3);
        }
        else {
            this.message.setText(`${username} wins the round!`)
        }
        const tween = this.scene.tweens.add({
            targets: this.message,
            scale: 2, // Final x position
            duration: 500, // Duration of the tween in milliseconds
            ease: 'Power2', // Easing function
            //yoyo: true, // Will make the tween go back and forth
            loop: 1, // Infinite loop
            onComplete: () => {
                tween.remove();
            }
            //paused: true // Start the tween paused
        });
    }

    displayRoundTie() {
        if (this.message === ""){
            this.message = this.scene.add.text(this.x, this.y, "Round tie!", { fontSize: 60*this.scale + "px", fontFamily: "TruculentaBold", fill: '#BD00FF', align: 'right' }).setOrigin(1, 0.5).setDepth(this.depth + 3);
        }
        else {
            this.message.setText("Round tie!")
        }
        const tween = this.scene.tweens.add({
            targets: this.message,
            scale: 1.3, // Final x position
            duration: 300, // Duration of the tween in milliseconds
            ease: 'Power2', // Easing function
            //yoyo: true, // Will make the tween go back and forth
            loop: 1, // Infinite loop
            onComplete: () => {
                tween.remove();
            }
            //paused: true // Start the tween paused
        });
    }
}

// Register a function to the gameobjectfactory, allowing you to use this.add.<objectname>
Phaser.GameObjects.GameObjectFactory.register("statusMessage", function (x, y, scale) {
    const statusMessageInst = new StatusMessage(this.scene, x, y, scale);

    this.displayList.add(statusMessageInst);
    this.updateList.add(statusMessageInst);

    return statusMessageInst;
})